import React from 'react';
import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import {fetchRoomTypes} from 'ducks/rooms';
import {MODALS as BASE_MODALS} from 'ducks/modals';

import {
  BookingCreateForm,
  BookingExtensionCreateForm,
  Buttons,
  BookingFormsNavigation
} from './components';

import './styles.css';

export const NEW_BOOKING_SECTION = 'newBooking';
export const BOOKING_EXTENSION_SECTION = 'bookingExtension';

export const BOOKING_CREATE_SECTIONS = {
  [NEW_BOOKING_SECTION]: 'New Booking',
  [BOOKING_EXTENSION_SECTION]: 'Extension'
};

class BookingCreateModal extends React.Component<any> {
  state = {selectedSection: NEW_BOOKING_SECTION};

  componentDidMount() {
    const {locationRef} = this.props;

    const fetchRoomTypesExtraActions = this.props.storeDataExtraActions(
      data => ({
        roomTypes: data
      })
    );

    this.props.fetchRoomTypes({locationRef}, fetchRoomTypesExtraActions);
  }

  getSelectedFormName = () => {
    const sectionToFormNameMapper = {
      [NEW_BOOKING_SECTION]: 'createBooking',
      [BOOKING_EXTENSION_SECTION]: 'createBookingExtension'
    };

    return sectionToFormNameMapper[this.state.selectedSection];
  };

  triggerFormSubmit = () => this.props.submit(this.getSelectedFormName());

  changeSelectedSection = section => this.setState({selectedSection: section});

  render() {
    const {
      locationRef,
      form: {createBookingSubmitting, createBookingExtensionSubmitting},
      data: {roomTypes = []}
    } = this.props;
    const {selectedSection} = this.state;
    const showBookingCreateForm = selectedSection === NEW_BOOKING_SECTION;
    const showBookingCreateExtensionForm =
      selectedSection === BOOKING_EXTENSION_SECTION;

    const modalType =
      selectedSection === NEW_BOOKING_SECTION ? Modal.EXTRA_SMALL : Modal.SMALL;

    return (
      <Modal
        show={true}
        type={modalType}
        onClose={this.props.closeModal}
        className="BookingCreateModal">
        <Modal.Header heading="Create a Booking" />
        <Modal.Body>
          <BookingFormsNavigation
            selectedSection={selectedSection}
            changeSelectedSection={this.changeSelectedSection}
          />
          <div className="BookingCreateModal__container">
            <BookingCreateForm
              showForm={showBookingCreateForm}
              locationRef={locationRef}
              storeDataExtraActions={this.props.storeDataExtraActions}
              getExtraActions={this.props.createBookingExtraActions}
              roomTypes={roomTypes}
            />
            <BookingExtensionCreateForm
              showForm={showBookingCreateExtensionForm}
              locationRef={locationRef}
              storeDataExtraActions={this.props.storeDataExtraActions}
              getExtraActions={this.props.createBookingExtraActions}
              roomTypes={roomTypes}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitting={
              createBookingSubmitting || createBookingExtensionSubmitting
            }
            onClose={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  form: {
    createBookingSubmitting: isSubmitting('createBooking')(state),
    createBookingExtensionSubmitting: isSubmitting('createBookingExtension')(
      state
    )
  }
});

const mapDispatchToProps = {
  fetchRoomTypes,
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal(
  BASE_MODALS.CREATE_BOOKING
)(BookingCreateModal) as React.ComponentType<any>);
